import { requestData, requestList } from '@/api/request';
import type { Tenant } from '@/api/types';

export async function getTenants(environmentId?: number) {
  return requestList<Tenant, never, { environment: number } | undefined>({
    url: 'tenants/',
    params: environmentId ? { environment: environmentId } : undefined,
  });
}

export async function getTenant(id: number) {
  return requestData<Tenant>({
    url: `tenants/${id}/`,
  });
}